export enum TipoDistribuidoraNombre {
  SAESA = 'SAESA',
  EDELAYSEN = 'EDELAYSEN',
  FRONTEL = 'FFRONTEL',
}
